import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg';
};

/** Shell de diálogo PA — mesmo layout de Monitorar agências / Editar seleção. */
export function MonitoringSelectionDialogShell({
  open,
  onClose,
  title,
  subtitle,
  children,
  actions,
  maxWidth = 'md',
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '10px',
          minHeight: maxWidth === 'md' ? '500px' : undefined,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#303030', textTransform: 'uppercase' }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#808080', mt: 0.25 }}>
              {subtitle}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>{children}</DialogContent>

      {actions && (
        <DialogActions sx={{ px: 3, py: 2, display: 'flex', width: '100%' }}>{actions}</DialogActions>
      )}
    </Dialog>
  );
}
